
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as _91_46_46_46slug_93kxjr4BRGYu8PjICw6eKIYYGNlIv1T0FK9GFhjf_45hT6QMeta } from "/opt/buildhome/repo/pages/[...slug].vue?macro=true";
import { default as indexBeHzAQikKrSJqk6imgHKGnYps5J2m1dpAlMAyv_MDnQMeta } from "/opt/buildhome/repo/pages/blog/index.vue?macro=true";
import { default as indexhGCaLCzdWsiUdwPW0A7DDZAhy8MLrE9laDi8jElTD7QMeta } from "/opt/buildhome/repo/pages/cart/index.vue?macro=true";
import { default as indexCiTQM4f507EixFMAptoePdtzKTGQyrTDZJC7L7iJ9IgMeta } from "/opt/buildhome/repo/pages/about/index.vue?macro=true";
import { default as _91slug_93TVXfQgR7E_1etoF9MB3cfpp6TKNvvtjRnrJxWZr59DgMeta } from "/opt/buildhome/repo/pages/blog/[slug].vue?macro=true";
import { default as index2J6hl4VN9QP3k3DnSBU4qYC2z2QcejnzMp7HA_45QZBIcMeta } from "/opt/buildhome/repo/pages/store/index.vue?macro=true";
import { default as indexe2rq5wAIBZhp029QVpKqPdSzd4buIQU1tPGtaH63RTYMeta } from "/opt/buildhome/repo/pages/[slug]/index.vue?macro=true";
import { default as _91slug_93fnUOeeUGSYs_a_45p5MU1N3aF8oKBIBz_4tUFlAinhBvMMeta } from "/opt/buildhome/repo/pages/store/[slug].vue?macro=true";
import { default as indexfiyD7ltz4JvSdoQF9hYUXkJL1LJEkPmX4JdF7IZdOowMeta } from "/opt/buildhome/repo/pages/contact/index.vue?macro=true";
import { default as _91child_93pca0YeKjA7bXfUoHwcdKLtcuiU5hllXVMLU2Lc5g4AkMeta } from "/opt/buildhome/repo/pages/[parent]/[child].vue?macro=true";
import { default as indexMVBkmD827ZiaMSQDCPcKtspShTTUmqk_45Sa8Rcrk5O4YMeta } from "/opt/buildhome/repo/pages/privacy-policy/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/opt/buildhome/repo/pages/[...slug].vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/opt/buildhome/repo/pages/blog/index.vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("/opt/buildhome/repo/pages/cart/index.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/opt/buildhome/repo/pages/about/index.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    component: () => import("/opt/buildhome/repo/pages/blog/[slug].vue")
  },
  {
    name: "store",
    path: "/store",
    component: () => import("/opt/buildhome/repo/pages/store/index.vue")
  },
  {
    name: "slug",
    path: "/:slug()",
    component: () => import("/opt/buildhome/repo/pages/[slug]/index.vue")
  },
  {
    name: "store-slug",
    path: "/store/:slug()",
    component: () => import("/opt/buildhome/repo/pages/store/[slug].vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/opt/buildhome/repo/pages/contact/index.vue")
  },
  {
    name: "parent-child",
    path: "/:parent()/:child()",
    component: () => import("/opt/buildhome/repo/pages/[parent]/[child].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/opt/buildhome/repo/pages/privacy-policy/index.vue")
  }
]